import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreloadService {

  constructor() { }

  preloadImages(arr: string[], images: HTMLImageElement[]): HTMLImageElement[] {
    for (let i = 0; i < arr.length; i++) {
      images[i] = new Image();
      images[i].src = arr[i];
    }
    return images;
  }

}
